import { fetchBaseQuery } from '@reduxjs/toolkit/dist/query';

export const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

export const urlWithVer = (endpoint, params = {}) => {
  params['api-version'] = process.env.REACT_APP_API_VERSION;
  const searchParams = new URLSearchParams(params);

  return `${endpoint}?${searchParams.toString()}`;
};

export const queryGet = (endpoint, params) => urlWithVer(endpoint, params);

export const queryPost = (endpoint, body, params) => ({
  url: urlWithVer(endpoint, params),
  method: 'POST',
  body,
});

export const queryPut = (endpoint, body) => ({
  url: urlWithVer(endpoint),
  method: 'PUT',
  body,
});

export const queryDelete = (endpoint) => ({
  url: urlWithVer(endpoint),
  method: 'DELETE',
});
